import React from 'react';
import { Mail, Phone, MapPin } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="bg-[#1a1a1a] text-white py-16">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="grid md:grid-cols-2 gap-12 mb-12">
          {/* Logo and Name */}
          <div>
            <div className="flex items-center gap-3 mb-4">
              <img
                // Swapped to your local file path
                src="/Images/Logo.png"
                alt="Ascend Digital"
                // Removed the forced white filter so your real logo shows up
                className="h-10 w-10 object-contain"
              />
              <span className="text-xl font-semibold">Ascend Digital</span>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Quick Links</h3>
            <ul className="space-y-2">
              <li>
                <button
                  onClick={() => document.getElementById('capabilities')?.scrollIntoView({ behavior: 'smooth' })}
                  className="text-gray-400 hover:text-white transition-colors duration-200"
                >
                  Capabilities
                </button>
              </li>
              <li>
                <button
                  onClick={() => document.getElementById('work')?.scrollIntoView({ behavior: 'smooth' })}
                  className="text-gray-400 hover:text-white transition-colors duration-200"
                >
                  Recent Work
                </button>
              </li>
              <li>
                <button
                  onClick={() => document.getElementById('process')?.scrollIntoView({ behavior: 'smooth' })}
                  className="text-gray-400 hover:text-white transition-colors duration-200"
                >
                  Process
                </button>
              </li>
              <li>
                <button
                  onClick={() => document.getElementById('technologies')?.scrollIntoView({ behavior: 'smooth' })}
                  className="text-gray-400 hover:text-white transition-colors duration-200"
                >
                  Technologies
                </button>
              </li>
            </ul>
          </div>
        </div>

        {/* Contact Info */}
        <div className="mb-12">
          <h3 className="text-lg font-semibold mb-4">Get In Touch</h3>
          <ul className="flex flex-wrap gap-8">
            <li className="flex items-center gap-3 text-gray-400">
              <Mail className="w-5 h-5" />
              <a href="mailto:aacambone@gmail.com" className="hover:text-white transition-colors">aacambone@gmail.com</a>
            </li>
            <li className="flex items-center gap-3 text-gray-400">
              <Phone className="w-5 h-5" />
              <a href="tel:+16479883307" className="hover:text-white transition-colors">+1 (647) 988-3307</a>
            </li>
            <li className="flex items-center gap-3 text-gray-400">
              <MapPin className="w-5 h-5" />
              <span>Toronto, ON</span>
            </li>
          </ul>
        </div>

        {/* Bottom Bar */}
        <div className="pt-8 border-t border-gray-800 text-center text-gray-400">
          <p>&copy; {new Date().getFullYear()} Ascend Digital. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;